!function () {
    let acceptedCookies = document.cookie.split('; ').find((row) => row.startsWith('accepted='));
    if (!acceptedCookies) {
        const cookieBlock = document.querySelector('.cookie-wrap');
        cookieBlock.style.cssText += 'display: flex;';
        document.querySelector('.cookie-btn').addEventListener('click', function () {
            document.cookie = "accepted=true";
            cookieBlock.style.cssText = 'display: none;';
        })
    }

    function r(e) {
        e = e.target.closest(".dropdown");
        e.classList.contains("opened") ? e.classList.remove("opened") : e.classList.add("opened");
    }

    document.querySelectorAll(".u-swiper").forEach(function (e) {
        var r = e.dataset.id;
        e.classList.add("swiper" + r), new Swiper(".swiper" + r, {
            loop: !0,
            allowTouchMove: !1,
            navigation: {
                nextEl: ".slides-arrows__right-" + r,
                prevEl: ".slides-arrows__left-" + r
            },
            pagination: {
                el: ".swiper-scrollbar-" + r,
                hide: !0
            }
        });
    }), document.querySelectorAll(".dropdown").forEach(function (e) {
        e.addEventListener("click", r);
    });

    new Swiper(document.querySelector(".land-slider__swiper__courses"), {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 60,
        breakpoints: {
            768: {
                slidesPerView: 2,
                // spaceBetweenSlides: 46
            },
            1400: {
                slidesPerView: 3,
                // spaceBetweenSlides: 40
            }
        },
        pagination: {
            el: ".swiper-pagination3",

            clickable: true,
        },
        navigation: {
            nextEl: ".right03",
            prevEl: ".left03"
        },

    })
    new Swiper(document.querySelector(".land-slider__swiper__courses2"), {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 60,
        breakpoints: {
            768: {
                slidesPerView: 2,
                // spaceBetweenSlides: 46
            },
            1400: {
                slidesPerView: 3,
                // spaceBetweenSlides: 40
            }
        },
        pagination: {
            el: ".swiper-pagination3",

            clickable: true,
        },
        navigation: {
            nextEl: ".right03",
            prevEl: ".left03"
        },

    })
    new Swiper(document.querySelector(".land-slider__swiper__courses3"), {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 60,
        breakpoints: {
            768: {
                slidesPerView: 2,
                // spaceBetweenSlides: 46
            },
            1400: {
                slidesPerView: 3,
                // spaceBetweenSlides: 40
            }
        },
        pagination: {
            el: ".swiper-pagination3",

            clickable: true,
        },
        navigation: {
            nextEl: ".right03",
            prevEl: ".left03"
        },

    })

    new Swiper(document.querySelector(".land-slider__swiper__shorts"), {
        allowTouchMove: true,
        loop: !0,
        pagination: {
            el: ".swiper-pagination2",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 20,
            }
        },

        navigation: {
            nextEl: ".land-slider__swiper__shorts-arr-right",
            prevEl: ".land-slider__swiper__shorts-arr-left"
        },
    });

    if (window.innerWidth < 1024) {
        new Swiper(document.querySelector(".land-slider__swiper__cards"), {
            loop: !0,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 40
                },
            },
            navigation: {
                nextEl: ".right02",
                prevEl: ".left02"
            },
        })
    }


}();
document.addEventListener('DOMContentLoaded', function () {
    let options = {
        root: null,
        threshold: 0.3
    }

    let callback = function (entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translate(0, 0)';
                observer.unobserve(entry.target)
            }
            /*            else {
                            entry.target.style.opacity = '0';
                            entry.target.style.transform = 'translate(0, 10px)';
                        }*/
        })

    }
    let observer = new IntersectionObserver(callback, options)
    let observer2 = new IntersectionObserver(callback, options)
    let observer3 = new IntersectionObserver(callback, options)

    let targetArr = document.querySelectorAll('.intersectionBlockInner')
    targetArr.forEach(el => {
        observer.observe(el)
    })

    let targetArr2 = document.querySelectorAll('.feature')
    targetArr2.forEach(el => {
        observer2.observe(el)
    })
    let targetArr3 = document.querySelectorAll('.card-spec')
    targetArr3.forEach(el => {
        observer3.observe(el)
    })

    let shorts = {
        'iframe-video-1': 'https://www.youtube.com/embed/N3R6ClDRL9w',
        'iframe-video-2': 'https://www.youtube.com/embed/oc3HGg7wzpM',
        'iframe-video-3': 'https://www.youtube.com/embed/8BU7lw3Mq20',
        'iframe-video-4': 'https://www.youtube.com/embed/CvM3VXE0QBc',
        'iframe-video-5': 'https://www.youtube.com/embed/qcxqgR9Lf3Q',
        'iframe-video-6': 'https://www.youtube.com/embed/IjKofIYNIC0',
        'iframe-video-7': 'https://www.youtube.com/embed/K1HZ_I_CBLA',
        'iframe-video-8': "https://player02.getcourse.ru/sign-player/?json=eyJ2aWRlb19oYXNoIjoiZGJhNDgwNDhlYmI5NTRlN2I5ODM4ZDI4NjQ4NjZhYzciLCJ1c2VyX2lkIjoyODExNjEzMjEsInN1Yl9sb2dpbl91c2VyX2lkIjpudWxsLCJsZXNzb25faWQiOm51bGwsImlwIjoiMjEzLjEzNS43Mi4yMCIsImdjX2hvc3QiOiJvbmxpbmUuc29zdGF2LnNjaG9vbCIsInRpbWUiOjE3MjYyMjE4NTgsInBheWxvYWQiOiJ1XzI4MTE2MTMyMSIsInVpX2xhbmd1YWdlIjoicnUiLCJ1c2VyX3JvbGUiOiJhZG1pbiJ9&amp;s=a10c3d9ceb7b477a45cec06e9bc14b92&amp;vh-static-feature=zigzag",
        'iframe-video-9': 'https://www.youtube.com/embed/i-lSWXnTGaQ',
        'iframe-video-10': 'https://www.youtube.com/embed/rTT_QTnsNVs',
    }
    let shorts2 = {
        'repina': '/static/landings/_defaults/vid/repina.mp4',
        'lazuchenkov': '/static/landings/_defaults/vid/lazuchenkov.mp4',
        'redko': '/static/landings/_defaults/vid/redko.mp4',
        'simon': '/static/landings/_defaults/vid/simon.mp4',
        'pitilimov': '/static/landings/_defaults/vid/pitilimov.mp4',
        'popov': '/static/landings/_defaults/vid/popov.mp4',
        'kirin': '/static/landings/_defaults/vid/kirin.mp4',
        'semchuk': '/static/landings/_defaults/vid/semchuk.MOV',
        'romanova': '/static/landings/_defaults/vid/romanova.mp4',
        'oleg': '/static/landings/_defaults/vid/oleg.MOV',
        'vdovichenko-shorts':  '/static/landings/_defaults/vid/vdovichenko-shorts.mp4',
        'pomerantsev':  '/static/landings/_defaults/vid/pomerantsev.mp4',
    }

    document.querySelector('.shorts').addEventListener('click', function (e) {
        if (e.target.classList.contains('swiper-slide')) {
            const videoId = e.target.getAttribute('id');
            for (const key in shorts) {
                if (videoId === key) {

                    var src = shorts[key];
                    if (key !== 'iframe-video-8') {
                        src += `?controls='0'&autoplay=1`
                    }

                    const iframe = document.createElement('div');
                    iframe.innerHTML = `
                        <iframe 
                            class="iframe-video" 
                            src="${src}" 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            allowfullscreen>
                            
                        </iframe>
                        <button class="iframe-close">&times;</button>
                        <div class="overlay"></div>`;
                    iframe.classList.add('iframe-video-wrap');

                    document.querySelector('.app__content').appendChild(iframe)

                }
            }
            for (const key in shorts2) {
                if (videoId === key) {
                    var addedClass;
                    const iframe = document.createElement('div');
                    iframe.innerHTML = `<video 
                                    class="iframe-video  ${addedClass}"  
                                    width = '250'  height = '475' controls
                                    autoplay="autoplay"> 
                                        <source src="${shorts2[key]}" type="video/mp4">
                                    </video>
                            <button class="iframe-close">&times;</button>
                            <div class="overlay"></div>`;

                    iframe.classList.add('iframe-video-wrap');

                    document.querySelector('.app__content').appendChild(iframe)


                }
            }
            document.querySelector('.overlay')
                ? document.querySelector('.overlay').addEventListener('click', function () {
                    document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
                }) : window.console.log(iframe);
            document.querySelector('.iframe-close').addEventListener('click', function () {
                document.querySelector('.app__content').removeChild(document.querySelector('.iframe-video-wrap'))
            })
        }
    })

    document.querySelector('.app').addEventListener('click', function (e) {
        let menu = document.querySelector('.hburger-menu');
        let burgerIcon = e.target.closest('.burger-icon');
        let innerMenu = e.target.closest('.hburger-menu');
        let btnClose = e.target.closest('.hburger-menu-close');
        if (burgerIcon) {
            menu.classList.contains('hidden') ? menu.classList.remove('hidden') : menu.classList.add('hidden')
        } else if (innerMenu) {
            if (btnClose) {
                menu.classList.add('hidden')
            }
        } else {
            menu.classList.add('hidden')
        }
    })
/*



    let deadline;
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    let today = year.toString() + ', ' + month.toString() + ', ' + day.toString();
    function getNextDeadline() {
        let time = new Date(today).getTime();
        if (Date.parse(new Date()) > Date.parse(new Date(time + 3600 * 22 * 1000))) {
            deadline =  new Date(time + 3600 * 34 * 1000)
        } else if (Date.parse(new Date()) > Date.parse(new Date(time + 3600 * 19 * 1000))) {
            deadline = new Date(time + 3600 * 22 * 1000)
        } else if (Date.parse(new Date()) > Date.parse(new Date(time + 3600 * 16 * 1000))) {
            deadline = new Date(time + 3600 * 19 * 1000)
        } else if (Date.parse(new Date()) > Date.parse(new Date(time + 3600 * 13 * 1000))) {
            deadline = new Date(time + 3600 * 16 * 1000)
        } else if (Date.parse(new Date()) > Date.parse(new Date(time + 3600 * 10 * 1000))) {
            deadline = new Date(time + 3600 * 13 * 1000)
        }

    }
    getNextDeadline();
    let hours;
    let mins;
    let sec;
    function getTimeRemaining(endtime){
        let t = Date.parse(endtime) - Date.parse(new Date());
        // sec = Math.floor( (t/1000) % 60 );
        if (t < 0) {
            getNextDeadline();
        }
        mins = Math.floor( (t/1000/60) % 60 );
        hours = Math.floor( (t/(1000*60*60)) % 24 );
    }

    let timerH = document.querySelector('.timer-h');
    let timerM = document.querySelector('.timer-m');

    function renderTime() {
        getTimeRemaining(deadline);
        // hours < 10 ? hours = '0' + hours : hours;
        // mins < 10 ? hours = '0' + mins : mins;
        if(timerH && timerM) {
            timerH.innerHTML = hours;
            timerM.innerHTML = mins;
            let dots = document.querySelector('.timer-dots');
            dots.classList.contains('hidden-dots') ? dots.classList.remove('hidden-dots') : dots.classList.add('hidden-dots')

        }
    }
    setInterval(() => renderTime(), 1000);

*/

});
